import React, { useEffect, useState } from "react";
import Styles from "./Navbar.module.css";
import { Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box
      className={`${Styles.navbar_container} ${
        scroll ? Styles.navbar_scrolled : ""
      }`}
    >
      <Stack className={Styles.navbar_logo_container}>
        <Stack
          className={Styles.navbar_logo}
          onClick={() => {
            navigate("/");
          }}
        >
          <img
            src="https://cdn.shopify.com/s/files/1/0039/6073/3763/files/OnestoLogo_desktop.png?v=1732256754"
            alt="logo"
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default Navbar;